import CellData from 'modules/_shared/components/Tables/CellData';
import screenSizes from 'constants/screenSizes';
import { anonymiseText } from 'utils/anonymiseText';

const isDevelopment = process.env.NODE_ENV === 'development';

const tableColumns = (i18n) => [
  {
    name: i18n.t('Id'),
    field: 'externalId',
    sortable: true,
    center: true,
    compact: true,
    grow: 0.7,
    minWidth: 40,
    selector: (row) => row[i18n.t('Id')],
    cell: (row) =>
      CellData.PlainText({
        text: row[i18n.t('Id')],
      }),
    export: true,
  },
  {
    // mandatory props
    name: i18n.t('Employee'),
    field: 'employee',
    selector: (row) => row[i18n.t('Employee')],
    sortable: true,
    // optional props
    grow: 2.5,
    cell: (row) =>
      CellData.Employee({
        employee: row[i18n.t('Employee')],
        societyId: row.societyId,
        url: '/detalle-empleado',
      }),
    export: true,
  },
  {
    name: i18n.t('Name'),
    field: 'name',
    selector: (row) => row[i18n.t('Name')],
    cell: (row) =>
      CellData.PlainText({
        text: row[i18n.t('Name')],
      }),
    export: false,
    omit: true,
  },
  {
    name: i18n.t('Email'),
    field: 'email',
    selector: (row) => row[i18n.t('Email')],
    cell: (row) =>
      CellData.PlainText({
        text: row[i18n.t('Email')],
      }),
    export: false,
    omit: true,
  },
  {
    name: i18n.t('Location'),
    field: 'location',
    selector: (row) => row[i18n.t('Location')],
    sortable: true,
    center: true,
    compact: true,
    cell: (row) =>
      CellData.PlainText({
        text: row[i18n.t('Location')],
      }),
    export: true,
    omit: true,
  },
  {
    name: i18n.t('Situation'),
    field: 'status',
    selector: (row) => row[i18n.t('Situation')],
    sortable: true,
    compact: true,
    cell: (row) =>
      CellData.BadgeText({
        text: row[i18n.t('Situation')]?.text,
        style: row[i18n.t('Situation')]?.color,
        outline: false,
      }),
    export: true,
  },
  {
    name: i18n.t('TaxId'),
    field: 'cif',
    selector: (row) => row[i18n.t('TaxId')],
    sortable: true,
    center: true,
    compact: true,
    cell: (row) =>
      CellData.PlainText({
        text: isDevelopment
          ? anonymiseText(row[i18n.t('TaxId')])
          : row[i18n.t('TaxId')],
      }),
    export: true,
    hide: screenSizes.LG,
  },
  {
    name: i18n.t('Type'),
    field: 'cifType',
    selector: (row) => row[i18n.t('Type')],
    sortable: true,
    center: true,
    compact: true,
    cell: (row) =>
      CellData.BadgeText({
        text: row[i18n.t('Type')]?.toUpperCase(),
        style: 'gray',
        outline: true,
      }),
    export: true,
    hide: screenSizes.LG,
  },
  {
    name: i18n.t('Salary'),
    field: 'salary',
    selector: (row) => row[i18n.t('Salary')],
    sortable: true,
    center: true,
    compact: true,
    cell: (row) =>
      CellData.NumberNoDecimals({
        value: row[i18n.t('Salary')],
      }),
    export: true,
    omit: true,
  },
  {
    name: i18n.t('Currency'),
    field: 'currency',
    selector: (row) => row[i18n.t('Currency')],
    sortable: true,
    center: true,
    compact: true,
    cell: (row) =>
      CellData.PlainText({
        text: row[i18n.t('Currency')],
      }),
    export: true,
    omit: true,
  },
  {
    name: i18n.t('Incentive'),
    field: 'hasIncentive',
    selector: (row) => row[i18n.t('Incentive')],
    sortable: true,
    compact: true,
    cell: (row) =>
      CellData.BadgeText({
        text: row[i18n.t('Incentive')]?.text,
        style: row[i18n.t('Incentive')]?.color,
        outline: false,
      }),
    export: true,
  },
  {
    name: i18n.t('ActivePlans'),
    field: 'activePlans',
    selector: (row) => row[i18n.t('ActivePlans')],
    sortable: false,
    center: true,
    compact: true,
    cell: (row) =>
      CellData.PlainText({
        text: row[i18n.t('ActivePlans')] ?? '-',
      }),
    export: true,
  },
];

export default tableColumns;
